

import React, { memo } from 'react';
import _get from 'lodash.get';
import { ADDON_ENTITY, PROJECT_TYPE } from '@shootsta/common-domain-data';
import { Text, Link } from '../../../../../../../ui-kit';
import {
  ExpandableBurnInCaptions,
  ExpandableSrtCaptions,
  ExpandableRushEdit,
  ExpandableVoiceOverArtist,
  ExpandableVoiceOverArtists } from
'../../../../../index';
import { MULTI, SINGLE } from '../../../../../constants/dropdownTypes';
import { withFlagsConsumer } from '../../../../../../FeatureFlags';

import '../styles/_master-output.scss';

const NEED_HELP_LINK = 'https://help.shootsta.com/en/articles/3503943-what-are-video-add-ons';
























function needHelpClick() {
  window.open(NEED_HELP_LINK, '_blank');
}

function getVisualBuilderScripts(videoScripts, projectType, animationOutput) {
  if (projectType === PROJECT_TYPE.ANIMATION && animationOutput) {
    const { animationScripts = [] } = animationOutput || {};
    return animationScripts;
  }
  return videoScripts && videoScripts.length ? videoScripts : [];
}

function MasterOutput({
  video,
  appliedAddons,
  onChangeAddon,
  canUpdateOutput,
  toggleVoiceOverModal,
  editingMode = false,
  changeSelectedSrtOrBurnIn,
  showAboutInfo,
  projectType,
  hideRushEdit = false,
  hideBurnInCaptions = false,
  hideSrtCaption = false,
  hideVoiceOver = false,
  hideVoiceOvers = false,
  flags,
  subHeading,
  submittedVoiceOverArtists = [],
  voiceOverPriceVersion
}) {
  const { animationOutput = {}, videoScripts = [] } = video || {};
  const visualBuilderScripts = getVisualBuilderScripts(videoScripts, projectType, animationOutput);

  const shouldShowRushEdit = projectType === PROJECT_TYPE.VIDEO && !hideRushEdit;
  const isPodcast = projectType === PROJECT_TYPE.PODCAST;

  const { disableRushEdit = false } = flags || {};

  const captionChangeHandler = (type) => (selected) => {
    if (changeSelectedSrtOrBurnIn) {
      changeSelectedSrtOrBurnIn(type, selected);
    }
  };

  return (
    <div className="master-output">
      {!editingMode &&
      <div className="master-output__header">
          <div>
            <Text className="master-output__heading" heading4 noMargin>
              Select from the options below
            </Text>
            {subHeading &&
          <Text label noMargin className="master-output__subHeading">
                {subHeading}
              </Text>}

          </div>
          {!isPodcast && <Link onClick={needHelpClick}>Need Help?</Link>}
        </div>}

      <div className="master-output__addons">
        {!disableRushEdit && shouldShowRushEdit &&
        <ExpandableRushEdit
          rushEdit={_get(appliedAddons, ADDON_ENTITY.RUSH_EDIT.type)}
          onChangeAddon={onChangeAddon}
          disabled={!canUpdateOutput}
          editingMode={editingMode}
          showAboutInfo={showAboutInfo} />}


        {!hideBurnInCaptions &&
        <ExpandableBurnInCaptions
          onCheckboxStateChange={captionChangeHandler(
            ADDON_ENTITY.BURN_IN_CAPTIONS.type
          )}
          onChangeAddon={onChangeAddon}
          burnInCaptions={_get(
            appliedAddons,
            ADDON_ENTITY.BURN_IN_CAPTIONS.type
          )}
          disabled={!canUpdateOutput}
          editingMode={editingMode}
          showAboutInfo={showAboutInfo} />}



        {!hideSrtCaption &&
        <ExpandableSrtCaptions
          onCheckboxStateChange={captionChangeHandler(
            ADDON_ENTITY.SRT_CAPTIONS.type
          )}
          onChangeAddon={onChangeAddon}
          srtCaptions={_get(appliedAddons, ADDON_ENTITY.SRT_CAPTIONS.type)}
          dropdownType={editingMode ? MULTI : SINGLE}
          disabled={!canUpdateOutput}
          editingMode={editingMode}
          showAboutInfo={showAboutInfo} />}


        {!hideVoiceOver &&
        <ExpandableVoiceOverArtist
          voiceOverArtist={_get(
            appliedAddons,
            ADDON_ENTITY.VOICE_OVER_ARTIST.type
          )}
          onChangeAddon={onChangeAddon}
          disabled={!canUpdateOutput}
          onInfoClick={() => toggleVoiceOverModal(true)}
          editingMode={editingMode}
          showAboutInfo={showAboutInfo} />}


        {!hideVoiceOvers &&
        <ExpandableVoiceOverArtists
          submittedVoiceOverArtists={submittedVoiceOverArtists}
          voiceOverArtists={_get(appliedAddons, 'VOICE_OVER_ARTISTS')}
          onChangeAddon={onChangeAddon('VOICE_OVER_ARTISTS')}
          disabled={!canUpdateOutput}
          onInfoClick={() => toggleVoiceOverModal(true)}
          withInfo
          editingMode={editingMode}
          showAboutInfo={showAboutInfo}
          visualBuilderScriptsList={visualBuilderScripts}
          voiceOverPriceVersion={voiceOverPriceVersion} />}


      </div>
    </div>);

}

export default withFlagsConsumer(memo(MasterOutput));